/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Why_Choose_TitleInputs */

const en_landing_why_choose_title = /** @type {(inputs: Landing_Why_Choose_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why job seekers choose Alchema`)
};

const de_landing_why_choose_title = /** @type {(inputs: Landing_Why_Choose_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum Jobsuchende Alchema waehlen`)
};

const fr_landing_why_choose_title = /** @type {(inputs: Landing_Why_Choose_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi les chercheurs demploi choisissent Alchema`)
};

const es_landing_why_choose_title = /** @type {(inputs: Landing_Why_Choose_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que los buscadores de empleo eligen Alchema`)
};

const it_landing_why_choose_title = /** @type {(inputs: Landing_Why_Choose_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perche i cercatori di lavoro scelgono Alchema`)
};

const nl_landing_why_choose_title = /** @type {(inputs: Landing_Why_Choose_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom werkzoekenden Alchema kiezen`)
};

const pl_landing_why_choose_title = /** @type {(inputs: Landing_Why_Choose_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dlaczego szukajacy pracy wybieraja Alcheme`)
};

const fi_landing_why_choose_title = /** @type {(inputs: Landing_Why_Choose_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miksi tyonhakijat valitsevat Alcheman`)
};

const da_landing_why_choose_title = /** @type {(inputs: Landing_Why_Choose_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvorfor jobsoegende vaelger Alchema`)
};

const sv_landing_why_choose_title = /** @type {(inputs: Landing_Why_Choose_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varfoer jobbsoekande vaeljer Alchema`)
};

/**
* | output |
* | --- |
* | "Why job seekers choose Alchema" |
*
* @param {Landing_Why_Choose_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_why_choose_title = /** @type {((inputs?: Landing_Why_Choose_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Why_Choose_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_why_choose_title(inputs)
	if (locale === "fr") return fr_landing_why_choose_title(inputs)
	if (locale === "es") return es_landing_why_choose_title(inputs)
	if (locale === "it") return it_landing_why_choose_title(inputs)
	if (locale === "nl") return nl_landing_why_choose_title(inputs)
	if (locale === "pl") return pl_landing_why_choose_title(inputs)
	if (locale === "fi") return fi_landing_why_choose_title(inputs)
	if (locale === "da") return da_landing_why_choose_title(inputs)
	if (locale === "sv") return sv_landing_why_choose_title(inputs)
	return en_landing_why_choose_title(inputs)
});